import styled from '@emotion/styled'
import { SpacerDefs, spacer } from '@pharmac/ui'

type IconContainerProps = SpacerDefs & {
  size?: number
}

export const IconContainer = styled.span<IconContainerProps>`
  display: inline-block;
  cursor: pointer;

  ${(p) =>
    p.size &&
    `
    width: ${p.size}px;
    height: ${p.size}px
   `};
  ${(p) => spacer(p)};
`
